import { createContext } from 'react';

const warehousesContext = createContext();

export default warehousesContext;
